<template>
  <div class="rma-addmessage position-relative">
      <absolute-loader :showLoader="callLoader"></absolute-loader>
      <div class="rma-addmessage_msg form-group">
        <h3 v-t="'informationPlus'" class="mb-3"></h3>
        <base-textarea
          name="rmaMessage"
          v-model="message"
          :placeholder="$t('rma.add_message')"
        />
      </div>
      <!-- attach file -->
      <div>
        <h3 v-t="'rma.add_files'" class="mb-3"></h3>
        <b-row class="upload-file-row">
          <b-col md="12">
            <div class="rma-addmessage_files mb-4_1 form-group">
              <b-form-group id="groupUploadFile" class="upload-file-label">
                <label class="custom-file-upload">
                  <input
                  id="form-file-img"
                  type="file"
                  class="d-none"
                  @change="processFile($event)"/>
                  <span class="upload-intro">
                    <i class="icomoon-icon icon-plus"></i>
                    {{$t('rma.add_files')}}
                  </span>
                </label>
                <ul class="files-list-text list-group">
                  <li v-for="(file, index) in _files" :key="file.lastModified" class="filename-list list-group-item">
                    <button @click="removeFile(index)" class="btn btn-none"><i class="icomoon-icon icon-x"></i></button>
                    {{file.name}}
                  </li>
                </ul>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <button type="button" class="btn btn-primary form-group" @click="sendMessage()" v-if="!creationForm">{{$t('Submit')}}</button>
      </div>
  </div>
</template>

<script>
import Rma from '@/services/Rma'
import BaseTextarea from 'theme/components/Form/BaseTextarea'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import { toast } from 'theme/modules/notifications'
import Logger from '@/services/Logger'

export default {
  props: {
    rmaId: {
      type: String,
      default: ''
    },
    reply: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: () => []
    },
    creationForm: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    callLoader: false
  }),
  computed: {
    message: {
      get () {
        return this.reply
      },
      set (newValue) {
        this.$emit('update:reply', newValue)
      }
    },
    _files: {
      get () {
        return this.files
      },
      set (newValue) {
        this.$emit('update:files', newValue)
      }
    }
  },
  methods: {
    sendMessage (rmaId) {
      const _this = this
      if (this.message || this._files.length) {
        if (!_this.creationForm) {
          this.callLoader = true
        }
        return Rma.attachment({
          token: this.$store.state.user.token,
          storeViewCode: this.$store.state.ui.storeViewCode,
          rmaId: rmaId || this.rmaId,
          message: this.message,
          files: this._files
        })
          .then(res => {
            if (res.data && res.data.success) {
              _this.$emit('saved')
              _this.emptyAll()
              return true
            } else {
              Logger.error(res)
              !_this.creationForm && toast.error(_this.$t('GenericError'))
            }
            return false
          })
          .catch(error => {
            Logger.error(error)
            !_this.creationForm && toast.error(_this.$t('GenericError'))
            return false
          })
          .finally(() => {
            _this.callLoader = false
          })
      }
      return Promise.resolve(true)
    },
    emptyAll () {
      $('#form-file-img + label').empty()
      this._files = []
      this.message = ''
    },
    processFile (event) {
      if (event.target.files.length) {
        this._files.push(event.target.files[0])
      }
    },
    removeFile (indexFile) {
      this._files.splice(indexFile, 1)
      $('#form-file-img + label').empty()
    }
  },
  components: {
    BaseTextarea,
    AbsoluteLoader
  }
}
</script>
